module.exports = __webpack_public_path__ + "static/media/pill-xarelto.88a80743.svg";